import RightRail from '../../libs/gs-component-right-rail';
import React from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { addPageRoute, reorderPagesRoute } from '../../helpers/routes';
import { AddPage } from './AddPage';
import { ReorderPages } from './ReorderPages';

export const ManagePagesRail: React.FC = () => {
  const history = useHistory();
  const match = useRouteMatch([reorderPagesRoute, addPageRoute]);

  const onClose = () => history.push('/gs/dashboard');

  return (
    <RightRail open={!!match} onEscapeKey={onClose}>
      <Switch>
        <Route exact path={reorderPagesRoute}>
          <ReorderPages onClose={onClose} />
        </Route>
        <Route exact path={addPageRoute} component={AddPage} />
      </Switch>
    </RightRail>
  );
};
